export default {"src":"/_next/static/media/icon-2.aed0963f.svg","height":79,"width":78,"blurWidth":0,"blurHeight":0};